<template>
  <v-col :style="forPartyEdit ? 'padding: 0px;' : ''">
    <v-form
      ref="form"
      @submit.prevent="submitForm"
    >
      <div :class="forPartyEdit? 'px-2' : 'pa-2'">
        <v-row align="start">
          <v-menu
            ref="menu"
            v-model="menuOpen"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template #activator="{ on }">
              <v-text-field
                ref="dateField"
                v-model="dateFormatted"
                :filled="!outlined"
                :outlined="outlined"
                :disabled="uncertainDate || inactive || disabled"
                :hint="hintText"
                :label="calculatedLabel"
                :placeholder="placeholderText"
                persistent-hint
                :rules="rules.date"
                :style="forPartyEdit ? 'width:80%' : ''"
                v-on="on"
                @change="parseManuallyEnteredDate"
                @focus="focusOpen"
                @keydown.tab="onTabOut"
              />
            </template>
            <v-date-picker
              v-model="dateInput"
              @input="menuOpen = false"
            />
          </v-menu>
          <v-checkbox
            ref="checkboxField"
            v-model="boxChecked"
            class="ml-2 shrink"
            hide-details
            :disabled="disabled"
            :rules="rules.uncertain"
          />
        </v-row>
      </div>
    </v-form>
  </v-col>
</template>

<script>
import dateFieldsMixin from '@/mixins/dateFields.js'

export default {
  name: 'ComboDateField',
  mixins: [dateFieldsMixin],

  props: {
    date: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    errorMessages: {
      type: Array,
      default: () => [],
    },

    forPartyEdit: {
      type: Boolean,
      default: false,
    },

    inactive: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      required: true,
    },

    outlined: {
      type: Boolean,
      default: false,
    },

    uncertain: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      dateFormatted: '',
      dateValidFromInput: true,
      menuOpen: false,
      rules: {
        date: [],
        uncertain: [],
      },
    }
  },

  computed: {
    boxChecked: {
      get () {
        return this.uncertain === true
      },

      set (newValue) {
        this.$emit('update-box', newValue)
      },
    },

    calculatedLabel () {
      return this.boxChecked && this.date ? `${this.label} (estimated)` : this.label
    },

    dateInput: {
      get () {
        return this.date
      },

      set (newDate) {
        this.dateFormatted = this.formatDate(newDate)
        if (newDate !== this.date) this.$emit('update-date', newDate)
      },
    },

    hintText () {
      if (this.errorMessages.length > 0) return this.errorMessages[0]
      return 'Check box if an ' + (this.date ? 'Estimated' : 'Unknown') + ' date.'
    },

    placeholderText () {
      return this.uncertainDate ? 'Unknown' : 'MM/DD/YYYY'
    },
  },

  created () {
    this.dateFormatted = this.formatDate(this.dateInput)
    this.addComboValidation()
  },

  methods: {
    onTabOut () {
      this.menuOpen = false
      this.$emit('tab-out')
    },

    submitForm () {
      this.$emit('submit')
    },
  },
}
</script>
